{
  "statusPill": {
    "new": "New",
    "planning": "Planning",
    "dataPrep": "Data Prep",
    "reportGen": "Report Gen",
    "complete": "Complete",
    "archived": "Archived"
  },
  "planItemEditor": {
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "saving": "Saving…",
    "title": "Title",
    "description": "Description",
    "method": "Method",
    "expectedOutput": "Expected output",
    "required": "This cannot be left blank.",
    "readTitle": "Title",
    "readDescription": "What it covers",
    "readMethod": "How",
    "readExpectedOutput": "Expected output"
  },
  "acceptGap": {
    "modal": {
      "title": "Accept section as a data gap",
      "body": "Accept this section as a gap and lock it. If the section already has content, the report keeps that content and marks it \"Accepted — Not Reconciled\". If it has none, the report shows \"Accepted — No Content\" in its place. Provide a brief reason so reviewers understand why the section could not be completed.",
      "placeholder": "Why is this section being accepted as a gap?",
      "cancel": "Cancel",
      "confirm": "Accept as gap",
      "submitting": "Accepting…"
    }
  },
  "list": {
    "title": "Workspaces",
    "empty": "No workspaces yet",
    "emptyHint": "Create your first workspace to get started.",
    "loading": "Loading workspaces...",
    "loadFailed": "Failed to load workspaces. Please refresh the page.",
    "createButton": "Create workspace",
    "search": "Search workspaces",
    "searchPlaceholder": "Search projects…",
    "lastModified": "Last modified",
    "createdAt": "Created {{date}}",
    "deleteConfirmTitle": "Delete workspace?",
    "deleteConfirmBody": "This will permanently delete the workspace, its files, plan, and any generated content. This cannot be undone.",
    "delete": "Delete",
    "cancel": "Cancel",
    "welcome": "Welcome back!",
    "welcomeSubtitle": "Start a new project or continue where you left off.",
    "yourProjectsTab": "Your projects",
    "loadingProjects": "Loading projects...",
    "projectsHeading": "Your projects",
    "projectsCount_one": "{{count}} project",
    "projectsCount_other": "{{count}} projects",
    "noProjects": "Your projects will appear here once you create one.",
    "viewLabel": "View",
    "editLabel": "Edit",
    "archiveLabel": "Archive",
    "ariaView": "view {{name}}",
    "ariaEdit": "edit {{name}}",
    "ariaArchive": "archive {{name}}",
    "projectsCount": "{{count}} projects"
  },
  "create": {
    "title": "Create workspace",
    "namePlaceholder": "Enter a descriptive project name",
    "nameLabel": "Project name",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "Describe the purpose and scope of this project",
    "verticalLabel": "Vertical",
    "serviceTypeLabel": "Service type",
    "outputLanguage": "Report language",
    "outputLanguageHint": "Generated reports will be written in this language. Cannot be changed after creation.",
    "strictness": "Finding strictness",
    "strictnessLenient": "Lenient",
    "strictnessBalanced": "Balanced (recommended)",
    "strictnessStrict": "Strict",
    "strictnessHint": "How aggressively findings are flagged. Lenient = only issues material to the regulatory verdict. Strict = every distinct deviation, including presentation and traceability. Balanced is the default. Cannot be changed after creation.",
    "aggregation": "Issue aggregation",
    "aggregationConsolidated": "Consolidated",
    "aggregationBalanced": "Balanced (recommended)",
    "aggregationGranular": "Granular",
    "aggregationHint": "How findings are grouped in the issue log. Consolidated = fewer, broader root-cause issues. Granular = every distinct finding as its own issue. Balanced is the default. Cannot be changed after creation.",
    "submit": "Create",
    "cancel": "Cancel",
    "creating": "Creating...",
    "errorGeneric": "Could not create workspace.",
    "errorTimedOut": "This took too long to complete. The project may not have been created — reopen the projects list to check before trying again.",
    "nameRequired": "Workspace name is required.",
    "newProjectTitle": "Create new project",
    "newProjectSubtitle": "Give your project a name and description to get started.",
    "editProjectTitle": "Edit project",
    "editProjectSubtitle": "Update your project details below.",
    "selectedWorkType": "Selected work type",
    "createButton": "Create project",
    "saveChanges": "Save changes",
    "newProject": "+ New project",
    "inheritedFrom": "Inherited from",
    "scopeLabel": "Scope",
    "landingNote": "You land in the project workspace"
  },
  "archive": {
    "title": "Archive project?",
    "body": "This will archive <strong>{{name}}</strong> and remove it from your active projects. You can restore it later from the archives.",
    "cancel": "Cancel",
    "confirm": "Archive"
  },
  "card": {
    "openButton": "Open",
    "deleteButton": "Delete",
    "renameButton": "Rename",
    "duplicateButton": "Duplicate",
    "stageLabel": "Stage",
    "filesLabel": "Files",
    "filesCount_one": "{{count}} file",
    "filesCount_other": "{{count}} files"
  },
  "files": {
    "referencesPartiallyMapped": "References partially mapped — retry on next change.",
    "referencesOverCap": "Cross-file relationship mapping isn't available for this workspace — it's too large to map (up to 200 source files are mapped). Your files are still fully indexed and searchable.",
    "title": "Files",
    "panelTitle": "Data Source",
    "viewFileMetadataTooltip": "View File Metadata",
    "ariaViewFileMetadata": "View file metadata",
    "ariaRetryProcessing": "Retry file processing",
    "ariaRemoveFile": "Remove file",
    "empty": "No files uploaded yet",
    "emptyHint": "Drop files here or click to browse.",
    "uploadButton": "Upload files",
    "browseButton": "Browse",
    "dropHere": "Drop files to upload",
    "dropHint": "PDF, DOCX, XLSX, CSV, TXT, MD, images",
    "uploading": "Uploading...",
    "uploadFailed": "Upload failed",
    "uploadSuccess": "Upload complete",
    "deleteFile": "Delete file",
    "deleteFileConfirm": "Delete {{name}}?",
    "deleteFileConfirmBody": "This file will be removed from the workspace.",
    "openFile": "Open",
    "downloadFile": "Download",
    "renameFile": "Rename",
    "metadataButton": "Metadata",
    "reviewMetadataButton": "Review metadata",
    "extractedFiles": "Extracted files",
    "filesUploaded_one": "{{count}} file uploaded",
    "filesUploaded_other": "{{count}} files uploaded",
    "fileTooLarge": "File too large (max {{max}}).",
    "unsupportedType": "Unsupported file type.",
    "selectFiles": "Select files",
    "fileName": "File name",
    "fileSize": "Size",
    "fileType": "Type",
    "fileStatus": "Status",
    "fileActions": "Actions",
    "category": "Category",
    "uncategorized": "Uncategorized",
    "uploadProgress": "{{name}} ({{percent}}%)",
    "approveFiles": "Approve files",
    "approveAndContinue": "Approve and continue",
    "approving": "Approving...",
    "rejectFile": "Reject",
    "approveFile": "Approve",
    "fileMissingMetadata": "Missing metadata",
    "fileNeedsAttention": "Needs attention",
    "fileReady": "Ready",
    "fileEnriching": "Enriching..."
  },
  "metadata": {
    "title": "File metadata",
    "reviewTitle": "Review file metadata",
    "reviewSubtitle": "Confirm the auto-detected metadata for each file before continuing.",
    "categoryLabel": "Category",
    "sourceLabel": "Source",
    "descriptionLabel": "Description",
    "descriptionPlaceholder": "What does this file contain?",
    "keyTopicsLabel": "Key topics",
    "tagsLabel": "Tags",
    "save": "Save",
    "cancel": "Cancel",
    "approveAll": "Approve all",
    "approveAllAndContinue": "Approve all and continue",
    "needsReview": "Needs review",
    "approved": "Approved",
    "approvedCount": "{{approved}} of {{total}} approved",
    "saving": "Saving...",
    "saveFailed": "Could not save metadata.",
    "noFiles": "No files to review.",
    "fileTypeLabel": "File type",
    "dataTypeLabel": "Data type",
    "coversSectionsLabel": "Covers sections",
    "loadingMetadata": "Loading metadata...",
    "notRecorded": "— not recorded",
    "extractedFromTitle": "Extracted from this file",
    "selectAll": "Select all",
    "clearSelection": "Clear selection",
    "filesSelected_one": "{{count}} file selected",
    "filesSelected_other": "{{count}} files selected",
    "fields": {
      "documentRole": "Document role",
      "documentRoleHelp": "What kind of role does this document play?",
      "contentDescription": "Content description",
      "dataType": "Data type",
      "contentCategory": "Content category",
      "keyTopics": "Key topics",
      "relevantSections": "Relevant sections",
      "dataFormat": "Data format"
    },
    "fieldLabels": {
      "content_description": "Content Description",
      "data_type": "Data Type",
      "document_role": "Document Role",
      "source_type": "Source Type",
      "author_or_source": "Author / Source",
      "reporting_period": "Reporting Period",
      "document_version": "Document Version",
      "key_topics": "Key Topics",
      "regulatory_frameworks": "Regulatory Frameworks",
      "user_description": "User Description",
      "content_category": "Content Category",
      "data_format": "Data Format",
      "has_tables": "Has Tables",
      "is_prior_period": "Prior Period",
      "source_sections": "Source Sections",
      "upload_source": "Upload source",
      "row_count": "Rows",
      "column_names": "Columns",
      "classification_kind": "Detected format"
    },
    "fieldDescriptions": {
      "source_sections": "List of section identifiers from the original source report",
      "target_template_section_ids": "List of template section IDs this file maps to",
      "data_requirements_matched": "List of data requirements this file satisfies",
      "key_topics": "Key topics and entities found in the file",
      "has_tables": "Whether the file contains tabular data",
      "table_count": "Number of tables found",
      "author_or_source": "Author, team, or originating system/vendor",
      "source_type": "Classification of the file's origin",
      "reporting_period": "The reporting period the file covers",
      "is_prior_period": "Whether this contains prior period data",
      "document_version": "Version identifier of the document",
      "regulatory_frameworks": "Applicable regulatory frameworks",
      "upload_source": "How this file was ingested into the workspace",
      "content_description": "A short description of what this file contains",
      "data_type": "The kind of data the file holds",
      "document_role": "The role this file plays in your reports",
      "user_description": "Your own description of the file",
      "content_category": "The category of content in the file",
      "data_format": "The format the data is stored in",
      "row_count": "Number of rows in the file",
      "column_names": "Names of the columns in the file",
      "classification_kind": "How the file's content was classified"
    },
    "enumValues": {
      "upload_source": {
        "user_upload": "User upload",
        "user_upload_sas": "User upload (large file)",
        "toolbox_extractor_import": "Toolbox: Extractor import",
        "toolbox_gatekeeper_import": "Toolbox: Gatekeeper import",
        "toolbox_reggie_import": "Toolbox: Test Ground import"
      },
      "document_role": {
        "model_documentation": "Model documentation",
        "regulatory_framework": "Regulatory framework",
        "test_data": "Test data",
        "test_results": "Test results",
        "historical_report": "Historical report",
        "supplementary": "Supplementary",
        "code_artifact": "Code artifact"
      },
      "data_type": {
        "unstructured": "Unstructured",
        "structured": "Structured",
        "image": "Image"
      },
      "source_type": {
        "internal_report": "Internal report",
        "regulatory_document": "Regulatory document",
        "vendor_material": "Vendor material",
        "model_documentation_package": "Model documentation package",
        "data_file": "Data file",
        "other": "Other"
      },
      "file_format": {
        "pdf": "PDF",
        "docx": "Word document",
        "xlsx": "Excel spreadsheet",
        "csv": "CSV",
        "txt": "Text",
        "other": "Other"
      },
      "section_type": {
        "report": "Report",
        "test_run": "Test run",
        "table": "Table",
        "verbatim": "Verbatim"
      }
    }
  },
  "tasks": {
    "descriptionLabel": "Task description",
    "descriptionPlaceholder": "Describe what you want to produce.",
    "saveTaskButton": "Save task",
    "saved": "Saved",
    "saving": "Saving...",
    "saveFailed": "Could not save task.",
    "templateLabel": "Output template",
    "templatePlaceholder": "Optional: paste a sample template or outline.",
    "saveTemplateButton": "Save template",
    "uploadTemplateButton": "Upload template",
    "removeTemplateButton": "Remove template"
  },
  "uploadFlow": {
    "step": {
      "upload": "Upload",
      "metadataReview": "Review metadata",
      "confirm": "Confirm & ingest"
    }
  },
  "evidenceMap": {
    "title": "Evidence map",
    "subtitle": "Trace each plan section back to the source files supporting it.",
    "noEvidence": "No evidence available yet.",
    "loading": "Loading evidence map...",
    "close": "Close",
    "viewSource": "View source",
    "section": "Section",
    "sources": "Sources",
    "coverage": "Coverage"
  },
  "issueLog": {
    "panelTitle": "Issue Log",
    "ariaLabel": "Issue log",
    "exportCsv": "Export CSV",
    "exporting": "Exporting…",
    "exportTooltip": "Download CSV (ignores current severity filter)",
    "scopeUnattributed_one": "{{count}} issue from this analysis is not linked to a plan item and is not shown here.",
    "scopeUnattributed_other": "{{count}} issues from this analysis are not linked to a plan item and are not shown here.",
    "csvExportFailed": "CSV export failed",
    "ariaCollapse": "Collapse issue log",
    "ariaExpand": "Expand issue log",
    "loadingIssueLog": "Loading issue log…",
    "updating": "Updating…",
    "retry": "Retry",
    "tableHeaderSeverity": "Severity",
    "tableHeaderFinding": "Finding",
    "tableHeaderSection": "Section",
    "tableHeaderGoTo": "Go to",
    "tableHeaderDetails": "Details",
    "noMatching": "No issues match the current severity filter.",
    "noIssues": "No issues.",
    "details": "Details",
    "ariaJumpToSection": "Go to source item {{id}}",
    "navigationUnavailable": "The source item is unavailable.",
    "tooltipJumpToSection": "Open the source item.",
    "stateLabelPreGate": "Issue log will populate after report self-check completes.",
    "stateLabelPopulating": "Preparing issue log…",
    "stateLabelAggregating": "Synthesizing root-cause issues…",
    "stateLabelEmpty": "No issues identified.",
    "stateLabelDrift": "Issue log populated, attribution drift flagged.",
    "stateLabelExtractionPaused": "Issue extraction paused — log will resume on next run.",
    "stateLabelPopulated_one": "{{count}} issue synthesized.",
    "stateLabelPopulated_other": "{{count}} issues synthesized.",
    "sortChip": "Sort: Severity {{direction}}",
    "severityRollup": "{{count}} Type {{tier}}",
    "stateLabelPopulated": "Populated",
    "supportsValidation": {
      "none_emitted": "This issue is a cross-cutting finding with no specific supporting symptoms attached.",
      "partial_invalid": "Some of the supporting-symptom references could not be resolved.",
      "none_valid": "None of the supporting-symptom references could be resolved, so this issue’s symptoms cannot be shown."
    },
    "relatedIssuesLabel": "Builds on:",
    "relatedIssueUnresolved": "an issue not in this log",
    "stateLabelFailed": "Issue log could not be compiled. Retry, or continue without one.",
    "stateLabelVersionFailed": "The latest report version could not be completed, so there is no issue log for it. Generate a new version.",
    "stateLabelSkipped": "No issue log — this report was compiled without one.",
    "retryAggregation": "Retry issue compilation",
    "skipAggregation": "Continue without an issue log",
    "tableHeaderFindingId": "ID",
    "tableHeaderStatus": "Status",
    "tableHeaderModelLog": "Model log",
    "statusReadOnlyExplainer": "Status is read-only here. Set it on the model’s issue log.",
    "statusOpen": "Open",
    "sectionNone": "No section",
    "openInModelLog": "Add this finding to the model's issue log",
    "openInModelLogNoModel": "This project is not attached to a model yet, so there is no model issue log to add to.",
    "openInModelLogUnavailable": "Adding a finding to the model issue log isn't available yet.",
    "loadFailed": "The issue log could not be loaded. Please try again.",
    "stateLabelLoadFailed": "Issue log unavailable — it could not be loaded.",
    "stateLabelUnknown": "The issue log is in an unexpected state, so it may be incomplete. Please try again or contact support.",
    "openInModelLogNoFindingUid": "This finding has no shared reference, so it cannot be added to the model issue log.",
    "escalateFailed": "This finding could not be added to the model issue log. Please try again.",
    "openInModelLogAlreadyAdded": "Already on the model issue log.",
    "escalateConfirmTitle": "Added to the model issue log",
    "escalateConfirmBody": "{{issueId}} is now on the model’s issue log.",
    "escalateConfirmDismiss": "Close"
  },
  "references": {
    "panelTitle": "References",
    "ariaLabel": "References",
    "ariaCollapse": "Collapse references",
    "ariaExpand": "Expand references",
    "loading": "Loading references…",
    "rebuilding": "References are rebuilding after a change to the report body.",
    "retry": "Retry",
    "ariaViewMetadata": "View metadata for {{filename}}",
    "dialogTitle": "Reference [{{number}}]",
    "ariaCloseDialog": "Close reference details",
    "documentRoleLabel": "Document Role",
    "dataTypeLabel": "Data Type"
  },
  "header": {
    "back": "Back",
    "settings": "Settings",
    "exportReport": "Export report",
    "exporting": "Exporting...",
    "exportFailed": "Export failed."
  },
  "page": {
    "ariaCollapseSidebar": "Collapse plan and data panel",
    "ariaExpandSidebar": "Expand plan and data panel",
    "loadFailed": "Failed to load workspace information.",
    "hydrateLoading": "Loading project",
    "hydrateStillWorking": "Still working…",
    "hydrateTimedOut": "This project could not be opened right now. Nothing was loaded, so nothing shown here would be complete.",
    "hydrateRetry": "Try again",
    "notFound": "Workspace not found. Redirecting to projects list.",
    "filesLoadFailed": "Failed to load workspace files.",
    "sectionsLoadFailed": "Failed to load sections.",
    "haltCannotClear": "Cannot clear halt: plan is not loaded. Reload the workspace.",
    "testRunCancelled": "Test run cancelled. You can restart or proceed to report generation.",
    "testRunCompleted": "Test run completed. Review results to proceed.",
    "testRunErrored": "Test run completed with errors. Review results for details.",
    "sourceUploadFailed": "Source file upload failed. Please retry.",
    "sourceUploadPartialFailed": "Uploaded {{uploaded}} of {{total}} files. {{failed}} failed: {{names}}. Please retry the failed files.",
    "sourceUploadSizeLimitHint": "{{count}} hit a size limit at the upload server — try splitting the file or contact support.",
    "metadataEnrichmentFailed": "Metadata enrichment failed. Please retry.",
    "taskUploadFailed": "Task description upload failed. Please retry.",
    "templateUploadFailed": "Output template upload failed. Please retry.",
    "taskDeleteFailed": "Failed to delete task description. Please retry.",
    "templateDeleteFailed": "Failed to delete output template. Please retry.",
    "mdrPromotionFailed": "The model development report could not be added to the source set. Please re-upload it as a source file.",
    "planGenTimeout": "Plan generation timed out. Please retry.",
    "enrichmentPartialWarning": "Some sections could not be fully enriched ({{enrichedCount}}/{{total}} fully enriched). Report generation will proceed with available detail.",
    "planApprovalFailed": "Plan approval failed. Please retry.",
    "planFeedbackFailed": "Plan feedback update failed. Please retry.",
    "planRefreshFailed": "Plan may not reflect latest changes. Try refreshing.",
    "reportGenFailed": "Report generation failed. Please retry.",
    "progressTrackingError": "Progress tracking error. Please retry.",
    "deleteFilesFailed_one": "Failed to delete {{count}} file. {{detail}}",
    "deleteFilesFailed_other": "Failed to delete {{count}} files. {{detail}}",
    "haltDefaultMessage": "Section generation is paused by an upstream issue. Clear the halt and retry to resume.",
    "haltDefaultPrompt": "Section generation is paused.",
    "testRunInProgress": "Test run in progress",
    "executingTestGroup": "Executing test group {{current}}/{{total}}",
    "executingTestGroupNamed": "Executing test group {{current}}/{{total}}: {{name}}",
    "executingTestGroups": "Executing test groups...",
    "cancelling": "Cancelling...",
    "cancelTestRun": "Cancel Test Run",
    "exportSuccess": "Report exported successfully.",
    "noSectionsToExport": "No sections to export. Generate sections first.",
    "exportFailedRetry": "Export failed. Please retry.",
    "exportFailedTitle": "Couldn't download your report",
    "exportTimedOut": "Your report took too long to prepare, so we stopped waiting. Nothing was changed — select Download to try again.",
    "cannotExportSections_one": "Cannot export: {{count}} section is not ready for export",
    "cannotExportSections_other": "Cannot export: {{count}} sections are not ready for export",
    "noSectionsToExportShort": "No sections to export",
    "sectionsNotReady": "Sections not yet ready:",
    "regenerateOrWait": "Regenerate the failing sections or wait for in-progress generation to complete before exporting.",
    "exportBlockedGeneratingTitle": "Sections are still generating",
    "sectionsStillGenerating": "Still generating:",
    "waitForGenerationToFinish": "Download becomes available again as soon as these sections finish.",
    "ariaDismissExportError": "dismiss export error",
    "exportBlockedInProgress": "Export blocked: some sections are still being generated. Wait for completion.",
    "dataGapSuffix_one": " ({{count}} section contains data gaps: {{names}}. Review [DATA GAP] markers in the document.)",
    "dataGapSuffix_other": " ({{count}} sections contain data gaps: {{names}}. Review [DATA GAP] markers in the document.)",
    "etlTimeout": "Processing is taking longer than expected. Data ingestion may still be running.",
    "etlFailedFiles": "Ingest failed — {{count}} file(s) encountered errors. Retry to re-ingest the workspace.",
    "cannotExportSections": "Cannot export — no self-checked sections.",
    "dataGapSuffix": " — {{count}} section(s) flagged as data gaps: {{names}}",
    "deleteFilesFailed": "Failed to delete {{count}} file(s)",
    "holisticPausedAlert_one": "Holistic self-check is paused — <strong>{{count}} section</strong> still needs to clear before the report can finish. Click <strong>{{retryAction}}</strong> on each failed section (or use <strong>{{bulkAction}}</strong> at the bottom of the report) to try again. If a section can't be recovered, click <strong>{{acceptGapAction}}</strong> on that section to ship the report anyway: a section that already has content keeps it, marked \"Accepted — Not Reconciled\", and one with no content shows \"Accepted — No Content\" in its place.",
    "holisticPausedAlert_other": "Holistic self-check is paused — <strong>{{count}} sections</strong> still need to clear before the report can finish. Click <strong>{{retryAction}}</strong> on each failed section (or use <strong>{{bulkAction}}</strong> at the bottom of the report) to try again. If a section can't be recovered, click <strong>{{acceptGapAction}}</strong> on that section to ship the report anyway: a section that already has content keeps it, marked \"Accepted — Not Reconciled\", and one with no content shows \"Accepted — No Content\" in its place.",
    "chatError": {
      "agent_timeout": "The assistant took too long to respond. Please try again.",
      "agent_crash": "The assistant ran into an error. Please try again.",
      "tool_call_failed": "A tool action ran into an error. Please try again.",
      "retrieval_miss": "No relevant information was found in your workspace.",
      "context_overflow": "The conversation is too long. Please start a new chat.",
      "concierge_classify_error": "I couldn't understand your request. Please rephrase and try again.",
      "workflow_state_guard": "This action isn't allowed at the current stage of your workspace.",
      "validation_error": "Your request has invalid fields. Please review and try again.",
      "not_found": "The workspace or plan wasn't found.",
      "unauthorized": "You don't have access to this resource.",
      "provider_error": "The AI provider is unavailable right now. Please try again shortly.",
      "plan_revision_unmatched_sections": "I couldn't make that change because it referred to sections that aren't in your plan. Your plan hasn't been changed — please try again, naming the sections you want to change.",
      "plan_revision_unmatched_sections_de_checklist": "I couldn’t apply that change because it referred to items outside your design-effective checklist. Nothing was changed. Please name the checklist items you want to change and try again.",
      "plan_revision_unmatched_sections_oe_checklist": "I couldn’t apply that change because it referred to items outside your operating-effective checklist. Nothing was changed. Please name the checklist items you want to change and try again.",
      "plan_revision_duplicate_sections": "I couldn't make that change because it named the same section more than once. Your plan hasn't been changed — please try again.",
      "plan_revision_integrity_failed": "The revision failed the plan integrity checks. Your plan was unchanged. Please clarify the changes you want.",
      "plan_revision_saved_response_failed": "Your revision was saved, but its confirmation failed. Review the saved plan before requesting another change.",
      "ingest_in_progress": "New evidence is still being added to this workspace. Please try again once it has been ingested.",
      "audit_gate_unavailable": "We couldn't check whether new evidence is still being added. Please try again in a moment.",
      "plan_already_approved": "This plan has been approved and is locked, so it can no longer be changed.",
      "plan_already_approved_report": "The report plan has been approved and is locked, so it can no longer be changed.",
      "plan_already_approved_de_checklist": "The design-effective checklist has been approved and is locked, so it can no longer be changed.",
      "plan_already_approved_oe_checklist": "The operating-effective checklist has been approved and is locked, so it can no longer be changed.",
      "plan_version_conflict": "This plan was changed since you last saw it, so nothing was changed. The latest version is now shown — please review it and send your request again.",
      "plan_version_conflict_report": "The report plan was changed since you last saw it, so nothing was changed. The latest version is now shown — please review it and send your request again.",
      "plan_version_conflict_de_checklist": "The design-effective checklist was changed since you last saw it, so nothing was changed. The latest version is now shown — please review it and send your request again.",
      "plan_version_conflict_oe_checklist": "The operating-effective checklist was changed since you last saw it, so nothing was changed. The latest version is now shown — please review it and send your request again.",
      "workspace_terminal": "This project is complete and read-only, so it can no longer be revised. You can still ask questions about it.",
      "workspace_archived": "This workspace has been archived and is read-only, so it can no longer be revised.",
      "workspace_model_archived": "The model this workspace belongs to has been archived, so the workspace is read-only and can no longer be revised.",
      "workspace_deleting": "This workspace is being deleted, so it can no longer be changed.",
      "content_filtered": "The assistant declined to respond to this request.",
      "unknown": "An unexpected error occurred. Please try again.",
      "run_item_regen_disabled": "Design- and operating-effective results can't be regenerated one item at a time. To change them, update the evidence and run the whole phase again."
    },
    "planGenError": {
      "plan_template_status_persist_failed": "Plan generation couldn't save your template's formatting status. No plan was saved. Please retry.",
      "template_block_labels_missing": "Plan generation couldn't tell which template pages are report content. No plan was saved. Please retry.",
      "template_block_labels_invalid": "Plan generation couldn't tell which template pages are report content. No plan was saved. Please retry.",
      "template_block_labels_unknown_id": "Plan generation referred to template pages that don't exist in your template. No plan was saved. Please retry.",
      "plan_structure_non_content_blocks_present": "Plan generation returned an unexpected structure. No plan was saved. Please retry.",
      "template_block_labelling_timeout": "Reading your template's pages took too long. No plan was saved. Please retry.",
      "template_block_labelling_failed": "Plan generation couldn't read your template's pages. No plan was saved. Please retry.",
      "template_label_contract_violation": "Your template couldn't be prepared for planning. No plan was saved. Please retry.",
      "template_constraint_invalid": "Your template couldn't be prepared for planning. No plan was saved. Please retry.",
      "constraint_extraction_failed": "Plan generation couldn't read the constraints in your task description. No plan was saved. Please retry.",
      "constraint_extraction_timeout": "Reading the constraints in your task description took too long. No plan was saved. Please retry.",
      "mdr_extract_failed": "The model development report for this project couldn't be read. Please re-upload and re-approve it (PDF or DOCX), then retry.",
      "audit_scope_extract_failed": "One of the scope documents for this project couldn't be read. Please re-upload it (PDF, DOCX, Markdown or TXT), then retry.",
      "plan_structure_max_rounds": "Plan generation couldn't finish building the plan structure. No plan was saved. Please retry.",
      "plan_structure_orphaned": "Plan generation produced sub-sections without their parent heading. No plan was saved. Please retry.",
      "enrichment_timeout": "Plan generation took too long while adding section details. Please try generating the plan again.",
      "enrichment_below_threshold": "Plan generation couldn't add details to enough sections. Please try generating the plan again.",
      "plan_template_labels_persist_failed": "Plan generation couldn't save your template's page layout. No plan was saved. Please retry.",
      "plan_template_outline_invalid": "We couldn't prepare your template for planning. Please re-export it from Microsoft Word, upload it again and retry.",
      "template_cleanup_contract_violation": "Your template couldn't be prepared from this plan. No plan was saved. Please retry.",
      "plan_template_drift": "Plan generation left out sections your template requires. No plan was saved. Please retry.",
      "template_parse_failed": "We couldn't read your template. Please re-export it from Microsoft Word and upload it again.",
      "missing_task_description": "We need a task description before generating a plan. Please upload one and retry.",
      "plan_structure_timeout": "The plan-structure step took too long to respond. Please retry.",
      "plan_structure_unparseable": "The plan-structure step didn't return usable results. Please retry.",
      "plan_merge_drift": "Plan enrichment produced inconsistent results. Please retry.",
      "no_sections_generated": "Plan generation didn't produce any sections after several attempts. Please retry.",
      "plan_persist_failed": "Plan generation completed but couldn't be saved. Please retry.",
      "plan_gen_unhandled": "Plan generation hit an unexpected error. Please retry.",
      "recoveredFailed": "Plan generation failed. Please retry or contact support.",
      "unknown": "Plan generation failed. Please retry.",
      "plan_gen_in_progress": "A plan is already being generated for this workspace. Please wait for it to finish.",
      "plan_already_exists": "A plan already exists for this workspace. Delete or revise it before generating a new one.",
      "enrichment_rate_limited": "Plan enrichment was rate-limited and could not finish after several retries. Please retry plan generation."
    },
    "etlFailedWorkspace": "Ingest failed before it could finish. No individual file reported an error. Retry to re-ingest the workspace.",
    "useAsMdrAction": "Use as model report",
    "useAsMdrConfirmTitle": "Use this report as the model's development report",
    "useAsMdrConfirmBody": "This report will be added to the model as a new version of its development report, pending approval. Until someone approves it on the model's overview page, plan generation uses it as an unapproved draft reference. Nothing is replaced and nothing is deleted — if this turns out to be the wrong report, withdraw the version there to retire it.",
    "useAsMdrConfirmAction": "Add to model",
    "useAsMdrSubmitting": "Adding…",
    "useAsMdrUnconfirmed": "This report was submitted to the model, but it hasn't appeared on the model's overview page yet. Check there before adding it again.",
    "useAsMdrFailed": "This report couldn't be added to the model. Please try again.",
    "haltClearAndRetry": "Clear halt and retry"
  },
  "cards": {
    "retryFromScratch": "Retry from scratch",
    "retrying": "Retrying...",
    "feedback": "Feedback",
    "acceptAsGap": "Accept as gap",
    "unreconciledGapTitle": "Accepted — Not Reconciled",
    "unreconciledGapBody": "The report validator asked for a revision to this section. The revision did not land, and the reviewer accepted the difference. The content below is the section's original, unrevised text.",
    "generationFailed": "Generation failed.",
    "contextDegraded": "Part of the reference material could not be used when this section was written, so it may be incomplete. Regenerate the section to try again.",
    "figuresNotShown": "The figures for this section were not shown to the model that wrote it, so the text may not refer to them. Regenerate the section with a model that can see figures to include them.",
    "generationFailedTransient": "Generation failed due to a temporary provider issue. Please wait a moment and retry.",
    "generationFailedHelper": "Generation failed. Click \"Retry from scratch\" to regenerate this section.",
    "bulkRegenInProgressTooltip": "Bulk regeneration is in progress — wait for it to finish before retrying individual sections.",
    "retryInProgressTooltip": "Retry is already in progress for this section.",
    "uploadSourceFiles": "Upload Source Files",
    "dropUnreadable": "That drop could not be read. Try the Files or Folder button instead.",
    "uploadingFile": "Uploading file...",
    "uploadingFiles": "Uploading {{count}} files...",
    "cancelUpload": "Cancel",
    "filesButton": "Files",
    "folderButton": "Folder",
    "uploadTip": "Tip: organize files in folders (e.g. <1>developer/</1>, <2>validator/</2>). Up to 200 source files per workspace. .zip and .egp archives are unpacked automatically — add them with the Files button or drag them in.",
    "uploadedFilesHeader": "Uploaded Files",
    "fileRemovedLabel": "Removed",
    "attentionEnrichmentIncomplete": "Attention — Enrichment Incomplete",
    "deleteFolderTitle": "Delete folder?",
    "deleteFolderBody_one": "This will permanently delete <1>{{count}}</1> file under",
    "deleteFolderBody_other": "This will permanently delete <1>{{count}}</1> files under",
    "deleteFolderHint": "The files and everything indexed from them are removed. Completeness will be re-evaluated afterward.",
    "deleteFolderConfirm_one": "Delete {{count}} file",
    "deleteFolderConfirm_other": "Delete {{count}} files",
    "deletingProgress": "Deleting…",
    "ariaDeleteFolder": "Delete {{count}} files in {{name}}",
    "testOutputTooltip": "Test output",
    "autoAddedReference": "Auto-added reference",
    "autoAddedReferenceWithStatus": "Auto-added reference · {{status}}",
    "statusReady": "Ready",
    "statusReadyLayoutWarning": "Ready, but some formatting couldn't be read",
    "statusProcessing": "Processing",
    "statusIngestedAssessmentPending": "Ingested — assessment pending",
    "statusAwaitingProcessing": "Awaiting processing",
    "statusNeedsReview": "Needs review",
    "statusIndexingFailed": "Indexing failed",
    "statusExtractionFailed": "Extraction failed",
    "statusFailed": "Failed",
    "statusDeletionIncomplete": "Deletion incomplete",
    "statusUnknown": "Unknown",
    "rejectedUnsupportedContent": "Not added — this file type isn’t supported, or the file isn’t readable text",
    "rejectedDefault": "Couldn't be added",
    "uploadedDate": "Uploaded {{date}}",
    "uploadedJustNow": "Uploaded Just now",
    "clickToBrowse": "Click to browse or drag and drop",
    "clickBrowseOrDrop": "Click to browse or drag and drop",
    "dragDropOrButtons": "Drag and drop, or use the buttons above",
    "supportedFileTypesLabel": "Supported: PDF, DOCX, PPTX, XLSX, XLS, CSV, MD, TXT, RST, IPYNB, JSON, NDJSON, Parquet, images, and plaintext source/config (PY, R, SQL, JS, TS, HTML, CSS, SH, YAML, TOML, INI, LOG, XML, etc.)",
    "planGenSupportedFileTypesLabel": "Supported: .docx, .pdf, .md, .markdown, .txt",
    "unsupportedPlanGenFile": "{{ext}} files aren't supported here — upload a .docx, .pdf, .md, .markdown, or .txt file.",
    "uploadTaskDescriptionLabel": "Upload Task Description",
    "uploadOutputTemplateLabel": "Upload Output Template",
    "taskDescriptionTitle": "Task Description",
    "taskDescriptionHelp": "Include detailed project requirements: overall objectives, constraints and compliance rules, data usage guidelines, expected output standards, and any other relevant information.",
    "outputTemplateTitle": "Output Template",
    "outputTemplateHelp": "Optionally provide a template or existing report to guide the sectional structure. If omitted, the plan structure will be derived from the task description and domain knowledge.",
    "outputTemplateOptional": "(optional)",
    "generatePlan": "Generate Plan",
    "generatingPlan": "Generating Plan...",
    "planReadyCelebrationTitle": "Plan Ready!",
    "planReadyCelebrationSubtitle": "Your execution blueprint is complete",
    "regenerateAllFailed": "Regenerate all failed",
    "regenerating": "Regenerating...",
    "bulkRegenStarted": "Regenerating {{n}} sections",
    "bulkRegenAlready": "Already regenerating {{n}} sections",
    "bulkRegenNone": "No failed sections to regenerate",
    "regenAlreadyRunning": "Regeneration is already running for this workspace. It will finish in the background — no need to click again.",
    "regenAlreadyRunningTooltip": "Regeneration is already running for this workspace — wait for it to finish before retrying this section.",
    "generationStillRunningTooltip": "Generation is still running.",
    "feedbackRegenRunningTooltip": "This section is being regenerated. Wait for it to finish before sending more feedback.",
    "singleRetryTooltip": "A single-section retry is in progress — wait for it to finish before regenerating all failed.",
    "exportTooltipInProgress": "Export in progress...",
    "exportTooltipNeedsSections": "Generate report sections first",
    "exportTooltipNeedsValidated": "At least one section must reach self-checked state (run holistic self-check or accept-as-is) before Download is available",
    "exportTooltipSectionGenerating": "A section is being regenerated — Download becomes available again when it finishes",
    "ariaSourceReference": "Source reference",
    "ariaFindingNavigate": "Navigate to {{findingId}} in home section",
    "ariaImageUnavailable": "Image source extraction failed — image unavailable",
    "badgeImageUnavailable": "⚠ Image unavailable — source extraction failed",
    "sectionPhase": {
      "extractingSymptoms": "Awaiting issue compilation",
      "aggregatingIssues": "Preparing issue log",
      "holisticValidating": "Self-checking...",
      "execSumGenerating": "Generating Executive Summary..."
    },
    "unsupportedFormatSkipped": "Unsupported format skipped: {{names}}",
    "approvedLabel": "Approved",
    "approvingLabel": "Approving…",
    "approvePlanLabel": "Approve Plan",
    "previousPlanLabel": "Previous plan",
    "supersededChip": "superseded",
    "noItemsInPlan": "No items in plan",
    "generatedExecutionPlan": "Generated Execution Plan",
    "planSummary_one": "I've generated a plan with {{count}} item based on your documents.",
    "planSummary_other": "I've generated a plan with {{count}} items based on your documents.",
    "requirementsLabel": "Requirements",
    "expectedOutputLabel": "Expected Output",
    "methodLabel": "Method",
    "testRunChip": "Test Run",
    "testRunBlurb": "This section generates test data for self-check — it does not produce report content.",
    "untitledItem": "(Untitled)",
    "execSummaryBlocked": "exec summary blocked",
    "execSummaryWaiting_one": " — waiting on {{count}} section",
    "execSummaryWaiting_other": " — waiting on {{count}} sections",
    "execSummaryBlockedDefault": "Executive summary is blocked until all body sections reach self-checked.",
    "execSummaryBlockedTooltip_one": "Blocked by {{count}} section: {{detail}}",
    "execSummaryBlockedTooltip_other": "Blocked by {{count}} sections: {{detail}}",
    "figureCaption": "Figure from source document",
    "deleteFolderConfirm": "Delete {{count}} file(s)?",
    "execSummaryBlockedTooltip": "Executive summary cannot generate yet — finish other sections first.",
    "execSummaryWaiting": "Waiting on dependent sections...",
    "planSummary": "Plan summary",
    "reportGenerated": "Report Drafted",
    "testRunInProgress": "Test run in progress...",
    "waitingForDataCheck": "Waiting for data check...",
    "mappingDocRelationships": "Mapping document relationships...",
    "loadingMethodologyContext": "Loading methodology context...",
    "preparingAnalysis": "Preparing analysis...",
    "analyzingDataCoverage": "Analyzing data coverage...",
    "finalizingReport": "Finalizing report...",
    "checkingData": "Checking data...",
    "uploadsPausedPipeline": "Uploads are paused while your files finish processing.",
    "reviewEvidenceAndGenerate": "Review Evidence & Draft Report",
    "preparingYourReport": "Drafting your report",
    "download": "Download",
    "planGen": {
      "buildingBlueprint": "Building execution blueprint",
      "phase": {
        "enriching": {
          "label": "Reading source material",
          "description": "Reading uploaded files for structure, context, and references."
        },
        "verifying_plan": {
          "label": "Reviewing plan alignment",
          "description": "Cross-checking the report plan against detected coverage gaps."
        },
        "preparing_template": {
          "label": "Applying template formatting",
          "description": "Cleaning the template, mapping placeholders, and staging styles."
        },
        "finalizing_template": {
          "label": "Saving template",
          "description": "Persisting the cleaned template for the report build."
        },
        "finalizing": {
          "label": "Finalizing",
          "description": "Generating each section and finalizing the report body."
        }
      }
    },
    "archiveError": {
      "bad_archive": "“{{archive}}” could not be opened — it may be corrupted or not a real archive. Nothing was added.",
      "empty_archive": "“{{archive}}” contains no files we can ingest. Nothing was added.",
      "archive_too_large": "“{{archive}}” is too large to unpack in the browser (limit {{limitMb}} MB). Unpack it locally and upload the folder instead.",
      "too_many_members": "“{{archive}}” has {{entries}} files and this workspace already has {{existing}} — the limit is {{limit}} source files. Nothing was added.",
      "zip_slip": "“{{archive}}” contains an unsafe file path and was not unpacked. Nothing was added.",
      "symlink_entry": "“{{archive}}” contains a shortcut/link entry, which cannot be ingested. Nothing was added.",
      "encrypted_archive": "“{{archive}}” is password-protected. Remove the password and try again.",
      "unsupported_compression": "“{{archive}}” uses a compression format we cannot read. Re-save it as a standard zip and try again.",
      "nested_archive": "“{{archive}}” contains another archive (“{{entry}}”). Unpack that one first, then upload. Nothing was added.",
      "duplicate_entry": "“{{archive}}” contains duplicate file paths and was not unpacked. Nothing was added.",
      "entry_too_large": "“{{archive}}” contains a file larger than {{limitMb}} MB. Nothing was added.",
      "compression_ratio": "“{{archive}}” contains a file that expands far beyond its stored size and was not unpacked. Nothing was added.",
      "unsupported_browser": "Your browser cannot unpack archives. Unpack “{{archive}}” locally and upload the folder instead.",
      "egp_missing_manifest": "“{{archive}}” is missing its SAS Enterprise Guide project file (project.xml) and could not be unpacked. Nothing was added.",
      "egp_bad_manifest": "“{{archive}}”’s SAS Enterprise Guide project file could not be read. Nothing was added.",
      "egp_unmapped_member": "“{{archive}}” contains a program (“{{entry}}”) that its SAS Enterprise Guide project file does not describe. Nothing was added."
    },
    "uploadTip_auditing": "Tip: organize audit evidence in folders by phase or control. Up to 200 source files per workspace. .zip and .egp archives are unpacked automatically — add them with the Files button or drag them in.",
    "unreconciledGapBody_auditing": "A revision to this audit section was requested but was not completed. The reviewer accepted the difference. The content below is the original, unrevised text.",
    "generationStopped": "Generation of this section was stopped by you. Use Retry to run it again.",
    "regenerateAllStopped": "Retry stopped sections",
    "stopGeneration": "Stop Generation",
    "generateBlockedTestRunning": "Test run in progress. Cancel or wait for completion before generating report.",
    "generateBlockedDataCheck": "Waiting for data check to complete before report generation can start.",
    "generateBlockedSectionRetry": "Some sections need a retry. Use each section's Retry button."
  },
  "dialogs": {
    "evidenceMap": {
      "title": "Review Evidence Map",
      "subtitle": "Select the files that provide evidence for each report section",
      "loading": "Loading evidence map...",
      "noPlanSections": "No plan sections to map. Approve a plan before generating the report.",
      "noFiles": "No source data files found. Upload files before generating the report.",
      "summary_one": "{{sections}} section across {{files}} file",
      "summary_other": "{{sections}} sections across {{files}} files",
      "orphanedChip_one": "{{count}} orphaned",
      "orphanedChip_other": "{{count}} orphaned",
      "orphanWarningTitle_one": "{{count}} file not selected for any section.",
      "orphanWarningTitle_other": "{{count}} files not selected for any section.",
      "orphanWarningBody": "They will be deprioritized during retrieval, not excluded.",
      "orphanWarningInstruction": "Click <1>Still proceed</1> to generate anyway, or go back and map them first.",
      "filesSelected_one": "{{selected}}/{{total}} file selected",
      "filesSelected_other": "{{selected}}/{{total}} files selected",
      "noFilesChip": "No files",
      "selectAll": "All",
      "selectNone": "None",
      "expandFolder": "Expand folder",
      "collapseFolder": "Collapse folder",
      "footerHint": "Adjust mappings below or generate directly — orphaned files are deprioritized, not excluded.",
      "cancel": "Cancel",
      "confirmGenerate": "Confirm & Generate",
      "stillProceed": "Still proceed",
      "ariaCloseDialog": "Close dialog",
      "filesSelected": "{{count}} files selected",
      "orphanWarningTitle": "Orphaned items",
      "orphanedChip": "Orphaned",
      "summary": "Evidence summary"
    },
    "fileMetadata": {
      "headerEnrich": "Enrich Your Data",
      "headerEnriching": "Enriching Your Data",
      "intro": "Descriptions help Bennie enrich metadata and build a richer understanding of your data. Optional at upload — you can review and edit metadata after enrichment completes.",
      "placeholderStructured": "Describe columns and data (optional)...",
      "placeholderGeneric": "Brief description (optional)...",
      "phraseAnalyzing": "Analyzing file structure...",
      "phraseExtracting": "Extracting key metadata...",
      "phraseIdentifying": "Identifying data types...",
      "phraseMapping": "Mapping content relationships...",
      "phraseRetrieval": "Building retrieval hints...",
      "phraseClassifying": "Classifying source materials...",
      "phraseTables": "Detecting content layout...",
      "phraseHeaders": "Skimming the file contents...",
      "phraseSignatures": "Reading file signatures...",
      "phraseScanning": "Scanning for key topics...",
      "phraseDensity": "Evaluating content density...",
      "phraseCrossRef": "Cross-referencing with plan...",
      "phraseProfiling": "Profiling what the file contains...",
      "phraseIndexing": "Indexing content sections...",
      "phraseDescriptors": "Generating search descriptors...",
      "phraseCatalog": "Cataloging source metadata...",
      "phraseCoverage": "Assessing data coverage...",
      "phraseRetrievalIndex": "Preparing retrieval index...",
      "phraseMatching": "Matching files to sections...",
      "phraseAlmostThere": "Almost there...",
      "headerEnrichmentComplete": "Enrichment complete",
      "headerEnrichingData": "Enriching your data",
      "completeWithReview_one": "{{enriched}} enriched, {{review}} need review",
      "completeWithReview_other": "{{enriched}} enriched, {{review}} need review",
      "completeNoReview_one": "{{count}} file enriched successfully",
      "completeNoReview_other": "{{count}} files enriched successfully",
      "statusPending": "Pending",
      "statusProcessing": "Processing",
      "statusReady": "Ready",
      "statusNeedsReview": "Needs Review",
      "statusFailed": "Not added",
      "startEnrichment": "Start Enrichment",
      "cancel": "Cancel",
      "ariaCloseDialog": "Close dialog",
      "closeTooltipRunning": "Close — enrichment continues in the background",
      "errorEnrichmentFailed": "Enrichment failed. Please close this dialog and try again.",
      "errorEnrichmentStartFailed": "Failed to start enrichment. Please close this dialog and try again.",
      "errorEnrichmentInProgress": "Enrichment for this workspace is already in progress. Please close this dialog — the running task will complete and update the file list automatically.",
      "errorEnrichmentUnexpected": "An unexpected error occurred during processing. Please close and try again.",
      "errorPollingUnstable": "Enrichment polling unstable ({{count}} failures). Still retrying...",
      "errorPollingMaxFailures": "Enrichment polling failed after multiple retries. Close and retry enrichment.",
      "statusEnriching": "Enriching {{name}}... ({{done}}/{{total}})",
      "statusEnrichingMetadata": "Enriching metadata... ({{done}}/{{total}})",
      "statusErrorEnrichment": "Error during enrichment",
      "statusErrorProcessing": "Error during processing",
      "cancelConfirmTitle": "Cancel enrichment?",
      "cancelConfirmBody_one": "1 file has already been uploaded and is waiting for enrichment.",
      "cancelConfirmBody_other": "{{count}} files have already been uploaded and are waiting for enrichment.",
      "cancelConfirmQuestion": "What would you like to do?",
      "discardFiles": "Discard uploaded files",
      "discardingFiles": "Deleting files...",
      "keepForLater": "Keep for later enrichment",
      "goBack": "Go back",
      "errorDiscardFailed": "Failed to delete one or more files. Please try again.",
      "cancelConfirmBody": "Discard the in-progress metadata changes?",
      "completeNoReview": "Complete without review",
      "completeWithReview": "Complete with review"
    },
    "metadataReview": {
      "title": "Review Enriched Metadata",
      "ariaCloseDialog": "Close dialog",
      "closeTooltip": "Close",
      "closeTooltipRunning": "Close — processing continues in the background",
      "instructionsBody": "Review and edit the enriched metadata for each file. All fields except file name and type are editable.",
      "ingestData": "Ingest Data",
      "ingestInProgressTooltip": "Data processing is already in progress.",
      "ingestNothingTooltip": "Add new files or edit metadata before ingesting.",
      "allFilesRejectedEmpty_one": "This file couldn't be added, so there is nothing to review. See the Data Source card for details.",
      "allFilesRejectedEmpty_other": "These {{count}} files couldn't be added, so there is nothing to review. See the Data Source card for details.",
      "cancel": "Cancel",
      "close": "Close",
      "ingestionFailed": "Data ingestion failed to start. Please close and retry.",
      "phraseIngesting": "Preparing your files for analysis...",
      "phraseExtractingText": "Extracting text content...",
      "phraseParsing": "Parsing file structure...",
      "phraseIndexingDocs": "Indexing documents...",
      "phraseBuildingIndex": "Building search index...",
      "phraseAnalyzingImages": "Analyzing images & OCR...",
      "phraseDataReady": "All set! Your data is ready.",
      "phraseDataCompleteness": "Data completeness check ongoing...",
      "phraseDataCoverage": "Evaluating data coverage...",
      "phraseMatchingPlan": "Matching files to plan sections...",
      "phaseChipETLComplete": "ETL Complete",
      "phaseChipPhase2": "Phase 2 — Indexing",
      "phaseChipPhase1Complete": "Phase 1 Complete",
      "phaseChipPhase1": "Phase 1 — Ingestion",
      "phaseChipFailed": "Failed",
      "phaseLibrarianRunning": "Mapping document relationships...",
      "phaseMappingReferences": "Loading methodology context...",
      "phasePromptBuilding": "Preparing analysis...",
      "phaseLLMCall": "Analyzing data coverage...",
      "phaseParsing": "Finalizing report...",
      "phaseDefault": "Evaluating data coverage...",
      "headerDataReady": "Data ready",
      "headerDataReadyPartial": "Data ready — {{count}} file(s) couldn't be indexed",
      "coverageNotSettled": "The coverage check did not finish loading. Close this window and use Re-check.",
      "headerPreparing": "Preparing your data",
      "headerIngestFailed": "Data ingest failed",
      "subtitleMayTake": "This may take a few minutes...",
      "phraseInitializing": "Initializing...",
      "fileStatusHeader": "File Status",
      "fileStatusReady": "Ready",
      "fileStatusFailed": "Failed",
      "fileStatusAttention": "Attention",
      "fileStatusPending": "Pending",
      "fileStatusIndexing": "Indexing",
      "fileStatusIngesting": "Ingesting",
      "ariaRetryFile": "Retry {{name}}",
      "tooltipRetry": "Retry this file",
      "tooltipRetryReingest": "Restart data ingestion for this workspace",
      "timeoutTitle": "Processing is taking longer than expected",
      "timeoutBody": "Processing may still be running. You can check again or close and return later.",
      "timeoutRetry": "Retry",
      "stillWorking": "Still working — this can take a few minutes for large or image-heavy files.",
      "addTagPlaceholder": "Add tag...",
      "addTagButton": "Add",
      "fileTypeLabel": "Type: {{type}}",
      "needsReviewChip": "Needs Review",
      "errorMetadataPhase1": "Metadata extraction failed — fill in content description manually and click Ingest Data, or re-upload the file in a supported format (PDF, DOCX).",
      "errorPhase1NotRun": "Metadata extraction did not run for this file — fill in content description manually and click Ingest Data, or re-upload the file.",
      "errorPhase2LlmFailed": "Metadata could not be generated automatically — review the fields below, fill in anything missing, and click Ingest Data.",
      "errorVisionFailed": "This image could not be described automatically — fill in content description manually and click Ingest Data, or re-upload the image.",
      "errorStructuredFailed": "This spreadsheet could not be summarised automatically — fill in content description manually and click Ingest Data.",
      "errorPlanMappingFailed": "This file could not be matched to report sections automatically — pick the sections it covers below and click Ingest Data.",
      "errorAttachmentExtractionFailed": "Attachments could not be read from this email — upload the attachments as separate files if the report needs them.",
      "errorImageIndexFailed": "This image could not be prepared for retrieval and will not appear in report results — re-upload it if the report needs it.",
      "errorEnrichmentDefault": "Enrichment incomplete — review and fill in missing fields.",
      "fieldHeaderField": "Field",
      "fieldHeaderValue": "Value",
      "showLess": "Show less",
      "advanced": "Advanced",
      "fieldYes": "Yes",
      "fieldNo": "No",
      "folderRoot": "(root)",
      "fileRetryFailed": "File retry failed. Please try again.",
      "phaseChipPhase": "Phase {{phase}}",
      "reEnrichTitle": "{{count}} file(s) need review",
      "reEnrichBody": "Their details couldn't be generated automatically. Fill in the fields below yourself, or try processing them again — files that are already complete won't be touched.",
      "reEnrichButton": "Try processing again",
      "reEnrichStarting": "Starting…",
      "reEnrichRunning": "Processing your files again…",
      "reEnrichRunningBody": "This can take a few minutes. The files below update as each one finishes.",
      "reEnrichNothing": "There was nothing left to process — these files have already been updated.",
      "reEnrichFailed": "Processing couldn't be started. Please try again.",
      "reEnrichTimeoutTitle": "Processing is taking longer than expected",
      "reEnrichTimeoutBody": "It may still be running. You can close this and come back later, or try again.",
      "reEnrichRecheck": "Check again",
      "reEnrichUnconfirmed": "We couldn't confirm whether processing started. The current status is shown below."
    },
    "reingestConfirm": {
      "title": "Restart data ingestion?",
      "body_one": "This restarts data ingestion for the <1>{{count}}</1> file in the workspace.",
      "body_other": "This restarts data ingestion for all <1>{{count}}</1> files in the workspace.",
      "hint": "Every file is processed again, including files that already completed. Completeness will be re-evaluated afterward.",
      "phaseBody_one": "This restarts data ingestion for the <1>{{count}}</1> file in {{phase}}.",
      "phaseBody_other": "This restarts data ingestion for all <1>{{count}}</1> files in {{phase}}.",
      "phaseHint": "Every file in this phase is processed again, including files that already completed. Coverage for this phase will be checked afterward.",
      "confirm": "Restart ingestion",
      "confirming": "Restarting…"
    },
    "testConfig": {
      "headerComposing": "Composing Test Pipeline...",
      "headerExecutionPlan": "Test Execution Plan",
      "groupsIdentified_one": "{{count}} test group identified",
      "groupsIdentified_other": "{{count}} test groups identified",
      "stage1Title": "Analyzing plan sections and matching tools...",
      "stage1Body": "Finding available tools, reading test procedures, and grouping plan sections into test groups.",
      "stage2Title": "Preparing pipeline{{suffix}}",
      "stage2TitleSuffix": " for group {{progress}}",
      "stage2TitleSuffixDefault": "...",
      "stage2Body": "Fetching tool definitions, composing pipeline code, and validating data requirements for each test group.",
      "stage2GroupCaption": "Group {{progress}}",
      "errorTitle": "Test plan composition failed",
      "errorWhatThisMeans": "<1>What this means:</1> a runnable test plan could not be produced for this workspace. Try again, and contact support if it continues.",
      "errorNextStep": "<1>Next step:</1> click \"Retry\" below. If it fails again, contact support with the workspace name and the time it happened.",
      "errorCompositionId": "composition_id: {{id}}",
      "compositionFailedDefault": "Test plan composition failed.",
      "noActionableResult": "No test groups could be produced for this workspace. Try again, or contact support if it continues.",
      "compositionFailedTemplate": "Failed to compose test plan: {{error}}",
      "compositionDoneNoGroups": "Composition completed but no test groups were returned.",
      "executionFailedTemplate": "Test execution failed: {{error}}",
      "partialFailureTitle_one": "Partial composition: {{count}} group failed to prepare",
      "partialFailureTitle_other": "Partial composition: {{count}} groups failed to prepare",
      "partialFailureNote": "You can proceed with the successfully composed groups or retry composition.",
      "coversSectionsLabel": "Covers plan sections:",
      "dataRequirementsHeader": "Input Data Requirements:",
      "pipelineCodeLabel": "Pipeline code:",
      "pipelineExpand": "Expand / Edit",
      "pipelineCollapse": "Collapse",
      "uploadHeaderMulti": "Upload Test Data (one file per group)",
      "uploadHintMulti": "Each test group may require a different data shape. Upload the file whose schema matches each group's data requirements. CSV, XLSX, or Parquet.",
      "uploadSelectedLabel": "Selected: {{name}} ({{size}} KB)",
      "uploadCoversShort": "covers: {{names}}{{ellipsis}}",
      "uploadChooseFileFor": "choose a file for this group",
      "uploadReplace": "Replace",
      "uploadChooseFile": "Choose file",
      "uploadHeaderSingle": "Upload Test Data (CSV, XLSX, or Parquet)",
      "uploadSizeKb": "{{size}} KB",
      "uploadHintSingle": "Click to browse or drag & drop the test dataset",
      "footerSummaryGroups": "{{uploaded}}/{{total}} groups have data selected",
      "footerSummaryFile": "Data: {{name}}",
      "footerSummaryUpload": "Upload test data to proceed",
      "footerTestsReady_one": "{{count}} test ready | {{status}}",
      "footerTestsReady_other": "{{count}} tests ready | {{status}}",
      "running": "Running...",
      "runTests_one": "Run {{count}} Test",
      "runTests_other": "Run {{count}} Tests",
      "cancel": "Cancel",
      "retry": "Retry",
      "kernelLabel": "Execution engine: {{phase}}",
      "kernelGroupsCompleted": "{{passed}} / {{total}} groups completed",
      "kernelSpawning": "Starting the execution engine...",
      "kernelReady": "Execution engine ready — executing test groups...",
      "kernelExecuting": "Executing test groups on the execution engine...",
      "kernelInProgress": "Test execution in progress...",
      "executionFailedAlert": "Test execution failed or timed out. You can close this dialog and retry.",
      "footerTestsReady": "{{count}} tests ready",
      "groupsIdentified": "{{count}} groups identified",
      "partialFailureTitle": "Partial failure",
      "runTests": "Run tests",
      "stage": "Stage"
    },
    "testResults": {
      "title": "Test Run Results",
      "subtitle": "Review and approve artifacts before generating the report",
      "allApprovedTitle": "All Tests Approved!",
      "allApprovedBody": "Test artifacts have been indexed and are ready for report generation.",
      "downloadCsv": "Download CSV",
      "generateReport": "Generate Report",
      "noArtifactsTitle": "No artifacts to display",
      "executionInProgressTitle": "Test execution in progress...",
      "executionInProgressBody": "Results will appear here when execution completes.",
      "noArtifactsBody": "Tool results have been cataloged as source data files and are ready for report generation.",
      "submitApprovals": "Submit Approvals",
      "submitting": "Submitting...",
      "cancel": "Cancel",
      "submitFailed": "Failed to submit approvals. Please try again.",
      "passLabel": "PASS",
      "failLabel": "FAIL",
      "untitledArtifact": "Tool {{n}}",
      "kernelArtifactDefault": "Execution artifact",
      "errorLabel": "Error",
      "noStructuredOutput": "Execution completed — no structured output.",
      "resultTooLarge": "Result data too large to display inline. Use Download CSV for full output.",
      "flaggedCells_one": "{{count}} flagged cell",
      "flaggedCells_other": "{{count}} flagged cells",
      "sectionLabelDefault": "Section {{n}}",
      "unexplainedPercent": "{{value}}% unexplained",
      "triggered": "Triggered",
      "ok": "OK",
      "emptyText": "(empty)",
      "flaggedCells": "Flagged cells"
    }
  },
  "softWarnings": {
    "ariaLabel": "Export soft warnings",
    "title_one": "Last export emitted {{count}} soft warning",
    "title_other": "Last export emitted {{count}} soft warnings",
    "intro": "The export completed successfully, but the document renderer flagged the following issues. The file is downloadable; subsequent exports will re-evaluate.",
    "sectionLabel": "Section {{id}}:",
    "sectionLabelTitled": "{{title}}:",
    "kinds": {
      "pandoc_stderr": "The document renderer reported an issue in this section.",
      "image_embed_failed": "An image in this section could not be included in the export.",
      "generic": "The document renderer reported an issue."
    },
    "truncated": "+{{count}} additional warnings not shown"
  },
  "templateStyle": {
    "titlePartial": "Template style partially preserved",
    "titleFailed": "Template style preservation failed",
    "ariaWarning": "Template style preservation warning",
    "bodyPartialPrefix": "{{warning}} Your template's fonts and spacing will still be applied to the exported report — cover page and section placement will use defaults.",
    "bodyPartialDefault": "Template structure could not be preserved.",
    "bodyFailedPrefix": "{{warning}} No effect on content generation.",
    "bodyFailedDefault": "Generic styling will be applied at export."
  },
  "sectionsTab": {
    "outputTemplateTitle": "Output Template",
    "outputTemplateOptional": "(optional)",
    "outputTemplateHelp": "Upload a template file to anchor the report's structure and styling.",
    "uploadOutputTemplateLabel": "Upload output template",
    "modelDevelopmentReportTitle": "Model Development Report",
    "mdrInheritedHelp": "This workspace's source files include the latest model development report from its parent model, whether approved or awaiting approval.",
    "mdrInheritedLoading": "Checking which model development report this workspace inherits…",
    "mdrInheritedUnreadable": "The inherited model development report could not be read just now, so this workspace cannot say what it inherits.",
    "mdrInheritedNoneApproved": "No model development report is in force for this workspace. Its parent model has no approved or pending version, so plan generation will run without one.",
    "mdrInheritedPendingApproval": "This workspace's parent model has a development report awaiting approval. Plan generation uses the latest version as an unapproved draft reference.",
    "mdrInheritedNotModelRooted": "This workspace was created before workspaces were registered under a model, so it has no parent model to inherit a development report from. Plan generation runs without one.",
    "mdrInheritedVersionMeta": "Version {{versionId}} · uploaded {{uploadedAt}}",
    "mdrInheritedOpenModel": "Open the model's development report",
    "uploadTaskDescriptionLabel": "Upload task description",
    "taskDescriptionTitle": "Task Description",
    "taskDescriptionHelp": "Upload a markdown or document file describing the scope of work.",
    "taskDescriptionHelp_validation": "Upload a markdown or document file describing the validation scope.",
    "taskDescriptionHelp_auditing": "Upload a markdown or document file describing the audit scope.",
    "taskDescriptionHelp_development": "Upload a markdown or document file describing the development scope.",
    "sectionPhase": {
      "extractingSymptoms": "Extracting symptoms...",
      "aggregatingIssues": "Aggregating issues...",
      "holisticValidating": "Holistic self-check...",
      "execSumGenerating": "Generating executive summary..."
    },
    "sectionStatus": {
      "pending": "Pending",
      "in_progress": "In progress",
      "context_ready": "Context ready",
      "context_unavailable": "Context unavailable",
      "generating": "Generating",
      "generated": "Generated",
      "pending_validation": "Pending self-check",
      "validating": "Self-checking",
      "validation_skipped": "Check skipped",
      "validated": "Self-checked",
      "approved": "Approved",
      "user_accepted_as_gap": "Accepted as gap",
      "needs_regen": "Needs regen",
      "failed": "Failed",
      "generation_failed": "Generation failed",
      "pending_phase_2c": "Pending",
      "generation_stopped": "Stopped"
    }
  },
  "markComplete": {
    "button": {
      "label": "Mark Complete"
    },
    "modal": {
      "title": "Mark workspace as complete?",
      "body": "Marking workspace as complete will lock all mutational actions. Only do this to lock down workspace context for future audit. Are you sure to proceed?",
      "cancel": "Cancel",
      "confirm": "Confirm",
      "success": "Workspace marked complete.",
      "alreadyComplete": "Workspace is already complete."
    }
  },
  "reportPreview": {
    "versionPagerMismatch": "Version v{{currentVersion}} is no longer available for this section. Try refreshing the section."
  },
  "dataPanel": {
    "ineligibility": {
      "archived": "This project is archived, so it can't take new source data.",
      "model_archived": "The model this project belongs to is archived, so this project can't take new source data.",
      "no_workflow_state": "This project hasn't been set up yet, so there's nowhere to put source data.",
      "report_generation_started": "Report generation has started, so this project is no longer accepting new source data.",
      "workspace_terminal": "This project is complete, so it can't take new source data.",
      "failed_state": "Resolve this project's failed step first, then add source data.",
      "workspace_busy": "This project is busy — wait for the current step to finish, then add source data.",
      "workspace_busy_before_plan": "You can add source data once the plan is approved.",
      "default": "This project can't take new source data right now."
    },
    "unavailable": "We couldn't check what you can do with this project's data. Refresh to try again."
  },
  "exportVersion": {
    "label": "Export version",
    "none": "Select a version"
  },
  "reportVersions": {
    "busy": "A report is being generated. A new version can be started once it finishes.",
    "collectionNotSettled": "A new version can be started once your files have finished processing.",
    "filesChanged": "Reference files have changed since Report V{{version}}: {{added}} added, {{removed}} removed. Generate a new version to include the changes.",
    "rejectedFilesNotice_one": "{{count}} file was not ingested because its format is not supported, so Report V{{version}} was generated without it. Upload CSV or JSON exports of that data to include it in a new version.",
    "rejectedFilesNotice_other": "{{count}} files were not ingested because their format is not supported, so Report V{{version}} was generated without them. Upload CSV or JSON exports of that data to include them in a new version.",
    "failed": {
      "report_generation_cancelled": "This version was stopped before it finished. The previous version is unchanged. Generate a new version.",
      "report_generation_cancelled_first": "This version was stopped before it finished. Generate a new version.",
      "generic": "This version could not be generated. The previous version is unchanged. Generate a new version.",
      "generic_first": "This version could not be generated. Generate a new version.",
      "halted": "This version stopped because generation is paused by an upstream issue. The previous version is unchanged. Use “{{clearHalt}}” to resume, then generate a new version.",
      "halted_first": "This version stopped because generation is paused by an upstream issue. Use “{{clearHalt}}” to resume, then generate a new version."
    }
  }
}
